import Config from '~/client/src/shared/Config'

const FIDHUB_WIDGET_SRC = 'https://fidhub.app/widget.js'
const FIDHUB_PROJECT_ID = '8052b8eb-4bd6-429f-bb1c-a9c8b38d5c66'

export default function loadFidhubWidget() {
  if ((Config.ENVIRONMENT || '').toLowerCase() !== 'development') {
    return
  }

  const script = document.createElement('script')
  script.src = FIDHUB_WIDGET_SRC
  script.async = true
  script.dataset.project = FIDHUB_PROJECT_ID
  document.body.appendChild(script)
}
